import { Link } from 'react-router-dom';
import { useSuscripcion } from '../../hooks/useSuscripcion';

/**
 * Franja que avisa cuando el acceso está por terminar o ya terminó.
 *
 * Aparece recién a 5 días del vencimiento. Mostrarla desde el primer
 * día la convertiría en parte del decorado y nadie la leería, que es
 * justo lo contrario de lo que se busca: que le dé tiempo de ir a
 * buscar el código antes de quedarse afuera.
 *
 * No se muestra nada mientras carga, para que no aparezca un aviso de
 * golpe medio segundo después de abrir la pantalla.
 */
export default function AvisoAcceso() {
  const { loading, tieneAcceso, porVencer, diasRestantes } = useSuscripcion();

  if (loading) return null;
  if (tieneAcceso && !porVencer) return null;

  const terminado = !tieneAcceso;

  return (
    <Link
      to="/canjear"
      className={`block mx-4 mb-4 rounded-2xl px-4 py-3 border transition-colors ${
        terminado
          ? 'bg-red-50 border-red-200 hover:bg-red-100'
          : 'bg-amber-50 border-amber-200 hover:bg-amber-100'
      }`}
    >
      <div className="flex items-center gap-3">
        <i
          className={`text-xl ${
            terminado ? 'ri-lock-2-line text-red-600' : 'ri-time-line text-amber-600'
          }`}
        ></i>
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-semibold ${terminado ? 'text-red-900' : 'text-amber-900'}`}>
            {terminado
              ? 'Tu acceso terminó'
              : `Te ${diasRestantes === 1 ? 'queda 1 día' : `quedan ${diasRestantes} días`}`}
          </p>
          <p className={`text-xs ${terminado ? 'text-red-700' : 'text-amber-800'}`}>
            Canjea un código y suma 3 meses.
          </p>
        </div>
        <i className={`ri-arrow-right-s-line text-xl ${terminado ? 'text-red-400' : 'text-amber-400'}`}></i>
      </div>
    </Link>
  );
}
